import { z } from "zod";
import { ClientApplicationType } from "../../hooks/types";

export const deviceSlugSchema = z.nativeEnum(ClientApplicationType);
